goog.provide('el8.data.model.user');

goog.require('el8.model.base');


el8.data.model.user = function(spec) { this.populate(spec); };
el8.data.model.user.inheritsFrom(el8_Entity);

// Staff ID is the ID of the user's associated "identity" 
// (ie Physician or OfficeStaff)
el8.data.model.user.addIntProperty('staffId');
el8.data.model.user.addStringProperty('staffType');
el8.data.model.user.addStringProperty('firstName');
el8.data.model.user.addStringProperty('middleName');
el8.data.model.user.addStringProperty('tin');
el8.data.model.user.addStringProperty('lastName');
el8.data.model.user.addStringProperty('fullName');
el8.data.model.user.addStringProperty('email');
el8.data.model.user.addStringProperty('directAddress');
el8.data.model.user.addBoolean('active');
el8.data.model.user.addBoolean('registered');
el8.data.model.user.addBoolean('admin');
el8.data.model.user.addBoolean('elationStaff');
el8.data.model.user.addBoolean('inWorkspace',false,true);


el8.data.model.user.prototype.isPhysician = function() { return this.getStaffType().cmp('Physician'); };
el8.data.model.user.prototype.isOfficeStaff = function() { return this.getStaffType().cmp('OfficeStaff'); };
el8.data.model.user.prototype.isPatient = function() { return this.getStaffType().cmp('Patient'); };
